import styled from 'styled-components'

export const TenantImageLink = styled.a`
  img#tenant-logo {
    width: auto !important;
    max-width: none !important;
  }
`;

export const TitleModal = styled.h2`
  color: #fff;
  text-align: center;
`;

export const TenancyListContainer = styled.div`
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-top: 30px;
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
`;

export const TenancyItem = styled.div`
    text-align: center;
    margin: 10px 15px;
    cursor: pointer;
    display: block;
    border-radius: 5px;
    padding: 0;
    clear: both;
    font-weight: 400;
    color: #212529;
    text-align: inherit;
    white-space: nowrap;
    background: white;
    border: 0;
    text-align: center;
    position: relative;
`;

export const TenancyName = styled.p`
  color: #dbdbdb;
`;

export const TenancyIcon = styled.div`
    background: gray;
    width: 200px;
    height: 150px;
    border-radius: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    &:hover {
        opacity: 0.85
      }
`;

export const TenantName = styled.span`
    color: #444;
`;

export const TenancyDescription = styled.div`
    width: 100%;
    text-align: center;
`;

export const ProfileDescription = styled.div`
    margin-left: 20px;
`;

export const ProfileContainer = styled.div`
    margin-top: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 20px;
`;

export const ProfileLink = styled.a`
    color: #fff;
    &:hover {
        color: #e4e4e4
      }
`;

export const ProfileItem = styled.p`
    font-size: 17px
`;

export const ProfileList = styled.div`
    
`;

export const BackLink = styled.a`
    color: #27aae1
`;

export const ContainerLoading = styled.a`
    color: #444
`;

export const ActiveBadge = styled.span`
    background: rgba(0, 0, 0, .4);
    border-radius: 50px;
    padding: 3px 20px;
    color: #fff;
    font-size: 14px;
`;

export const TenancyActiveBadge = styled(ActiveBadge)`
    position: absolute;
    bottom: 28px;
`;

export const ProfileActiveBadge = styled(ActiveBadge)`
    margin-left: 10px;
    padding: 2px 12px;
    font-size: 12px;
    vertical-align: middle;
    background: rgba(255, 255, 255, .2);
`;

export const ActiveProfileLink = styled.span`
    color: #fff;
    font-weight: 700;
    cursor: default;
`;

export const SearchContainer = styled.div`
    position: relative;
    width: 100%;
    max-width: 420px;
    margin: 20px auto 0;

    svg {
        position: absolute;
        left: 14px;
        top: 50%;
        transform: translateY(-50%);
        color: rgba(255, 255, 255, .6);
    }
`;

export const SearchInput = styled.input`
    width: 100%;
    height: 42px;
    padding: 0 14px 0 40px;
    border-radius: 5px;
    border: 1px solid rgba(255, 255, 255, .2);
    background: rgba(255, 255, 255, .1);
    color: #fff;
    font-size: 15px;
    outline: none;

    &::placeholder {
        color: rgba(255, 255, 255, .6);
    }

    &:focus {
        border-color: #27aae1;
    }
`;

export const EmptySearch = styled.p`
    width: 100%;
    margin-top: 30px;
    color: rgba(255, 255, 255, .8);
    text-align: center;
`;
